/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/
/* eslint-disable @typescript-eslint/no-explicit-any */

import React, { useEffect, ReactElement, useState, ReactNode } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

type Props = {
	children?: ReactNode;
	path?: string | null;
	lastStepFn: () => void;
};

const defaultProps = {
	children: null,
	path: null,
};

const Steps = ({ children, lastStepFn }: Props): ReactElement => {
	const [index, setIndex] = useState(0);
	const history = useHistory();
	const location = useLocation();
	const childrenArray = React.Children.toArray(children);

	const goToIndex = (newIndex: number) => {
		setIndex(newIndex);

		if (newIndex >= 0 && childrenArray.length > newIndex) {
			const { props } = childrenArray[newIndex] as any;
			if (props.path && location.pathname !== props.path) {
				history.push({ pathname: props.path, search: location.search });
			}
		}
	};

	useEffect(() => {
		const stepAlias = location.pathname.split('/').pop();
		const stepIndex = childrenArray.map((child) => (child as any).props.stepId).indexOf(stepAlias);

		if (index !== -1 && stepIndex !== -1 && stepIndex !== index) {
			goToIndex(stepIndex);
		} else {
			goToIndex(index);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	if (childrenArray.length === 0 || childrenArray.length <= index || index < 0) {
		return <div />;
	}

	const moveNext = index + 1 === childrenArray.length ? lastStepFn : () => goToIndex(index + 1);
	return React.cloneElement(childrenArray[index] as ReactElement, { moveNext });
};

Steps.defaultProps = defaultProps;

export default Steps;
